import { useSnapshot } from 'valtio'
import React, { type ReactElement } from 'react'
import { SlideOver } from '../../../../../../../../shared/components/ui/SlideOver'
import { rpOccurrenceProxy } from '../../../rpOccurrenceProxy'
import { executeRecurringTransactionRetry } from '../../utils/executeRecurringTransactionRetry'
import { recurringPaymentProxy } from '../../../../../../../../shared/proxies/recurringPaymentProxy'
import { RecurringPaymentStatus } from '../../../../../../../../shared/types/GlobalRecurringPaymentsStatus'
import { GtagEvents, gtmTrackButtonPress } from '../../../../../../../../shared/utils/gtmUtils'
import { SimpleChargeError } from '../../../../../../../../shared/components/ui/SimpleChargeError'
import { RpOccurrenceCreditCardDropDown } from './RpOccurrenceCreditCardDropDown'
import { UpdateCardRadioSection } from './UpdateCardRadioSection'
import { resetRpOccurrenceEditProxy, rpOccurrenceEditProxy } from './rpOccurrenceEditProxy'
import { ResumeChargesSection } from './ResumeChargesSection'

const cancelFunction = (): void => {
  rpOccurrenceProxy.displayUpdateCardSlideOver = false
  gtmTrackButtonPress(GtagEvents.CARD_MODAL_CANCEL)
  resetRpOccurrenceEditProxy()
}

export function CardUpdateSlideOver (): ReactElement {
  const { displayUpdateCardSlideOver } = useSnapshot(rpOccurrenceProxy)
  const { allowSubmit } = useSnapshot(rpOccurrenceEditProxy)
  const { recurringPayment, retryApiCall: { error, errorCode } } = useSnapshot(recurringPaymentProxy)

  return (
    <SlideOver
      submitText="Retry Transaction"
      canSubmit={allowSubmit}
      isOpen={displayUpdateCardSlideOver}
      title="Update Card and Retry"
      cancelFunction={cancelFunction}
      submitFunction={executeRecurringTransactionRetry}
    >

      <RpOccurrenceCreditCardDropDown />
      <UpdateCardRadioSection />

      <div className="flex flex-col mb-6">
        <hr className="border border-gray-600 my-2" />
      </div>
      <ResumeChargesSection isActive={recurringPayment?.status === RecurringPaymentStatus.Active} />
      {(error && errorCode) && (
        <SimpleChargeError error={error} errorCode={errorCode} />
      )}
    </SlideOver>
  )
}
